export default "<div id=\"container\" class=\"\" [ngStyle]=\"height > rectSpacing ? { 'background-color': 'white' } : ''\" style=\"overflow: hidden\"></div>\n"